module.exports = __webpack_public_path__ + "img/069-british-indian-ocean-territory.dacfa8ad.svg";